module.exports = __webpack_public_path__ + "img/hero-visual.b144c0a8.svg";